import React from 'react';
import {Button} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../../_metronic/_helpers";
import PopupDeleteSaved from "./PopupDeleteSaved";

export function SavedQueriesActionsColumnFormatter(cellContent, {handleCloseModal, setFieldValue, applyFilter}) {

  return (
    <div className="d-flex align-items-center justify-content-center">
      <Button
        className={"btn btn-icon btn-light btn-sm mr-4 custom-action-button"}
        onClick={() => {
          const values = {
            query: cellContent?.query ?? '',
            reportId: String(cellContent?.reportId ?? ''),
          };

          void setFieldValue('query', values.query);
          void setFieldValue('reportId', values.reportId);

          applyFilter(values);
          handleCloseModal();
        }}
      >
        <img
          src={toAbsoluteUrl('/media/svg/Check_brandColor.svg')}
          alt="i" width={30}
        />
      </Button>
      <PopupDeleteSaved id={cellContent?.reportId}/>
    </div>
  )
}
